module.exports = __webpack_public_path__ + "img/letitia-still.1cf62c38.png";